





























import Vue from "vue";
import { UpdateTypeEnum, GetI18nStringFromUpdateType } from "@/model/data/enums/UpdateTypeEnum";
import { UpdateVersionInfo } from "@/model/data/updates/UpdateVersionInfo";

export default Vue.extend({
    data() {
        return {
            UpdateTypeEnum,
        };
    },
    props: {
        sws: { type: Array },
        updateType: { type: Number },
        showVersions: { type: Boolean },
    },
    computed: {
        atLeastOneToUpdate(): boolean {
            var res: boolean = false;
            this.sws.forEach((sw: UpdateVersionInfo) => {
                if (!sw.isUpToDate) {
                    res = true;
                }
            });
            return res;
        },
    },
    methods: {
        GetI18nStringFromUpdateType,
    },
});
